<ng-container *transloco="let t; prefix: scope">
  <div class="flex h-full items-center gap-4" [class.nc-container]="!fullWidthHeader()">
    <rma-site-header-logo [renownedBranding]="renownedBranding()" />

    <rma-site-header-search
      class="opacity-100 transition-opacity"
      [scope]="scope"
      [class.opacity-0!]="basicHeader()"
      [class.pointer-events-none]="basicHeader()"
    />

    <div
      class="flex h-full grow items-center justify-end gap-2 opacity-100 transition-opacity"
      [class.opacity-0!]="basicHeader()"
      [class.pointer-events-none]="basicHeader()"
    >
      <rma-site-header-compare-agent
        [scope]="scope"
        [compareCount]="compareCount()"
        [agents]="compareAgents()"
        (removeAgent)="onRemoveCompareAgent($event)"
        (compare)="onCompareAgents()"
      />

      @defer (when trackedCount()) {
        <rma-site-header-track-campaign [scope]="scope" [trackedCount]="trackedCount()" />
      } @error {}

      @if (showMarketingNav()) {
        <rma-site-header-navigation
          class="hidden md:block"
          [scope]="scope"
          [story]="story()"
          [reviews]="reviews()"
          [agents]="agents()"
          [group]="group()"
          displayMode="inline"
        />
      }

      @if (showUser()) {
        @defer (when showUser()) {
          <rma-site-header-user class="md:ml-4" [scope]="scope" [userType]="userType()" />
        } @error {}
      } @else {
        <rma-site-header-login class="md:ml-4" [scope]="scope" />
      }

      @if (showMarketingNav()) {
        <rma-site-header-navigation
          class="md:hidden"
          [scope]="scope"
          [sideNavOpen]="sideNavOpen()"
          (toggleSideNav)="toggleSideNav()"
          displayMode="menu"
        />
      }
    </div>

    @if (loginHeader()) {
      <rma-site-header-logo [loginHeader]="true" />
    }
  </div>
</ng-container>
